import React from 'react';
import { Link } from 'react-router-dom';
import './ToolRecommendationsBanner.css';

/**
 * Chat / Tools UI for structured tool_recommendations metadata.
 */
export default function ToolRecommendationsBanner({
  recommendations = [],
  title = 'Recommended tools',
  onEnableDefaults,
  enabling = false,
  compact = false,
}) {
  const items = Array.isArray(recommendations) ? recommendations.filter(Boolean) : [];
  if (!items.length) return null;

  return (
    <div className={`tool-recs-banner${compact ? ' is-compact' : ''}`} role="region" aria-label={title}>
      <div className="tool-recs-banner__title">
        <i className="fas fa-lightbulb" aria-hidden /> {title}
      </div>
      <ul className="tool-recs-banner__list">
        {items.map((rec, idx) => (
          <li key={`${rec.id || rec.kind || idx}-${rec.reason || idx}`} className="tool-recs-banner__item">
            <div className="tool-recs-banner__item-title">{rec.title || rec.label || rec.kind}</div>
            {rec.message || rec.description ? (
              <div className="tool-recs-banner__item-msg">{rec.message || rec.description}</div>
            ) : null}
            {Array.isArray(rec.sample_urls) && rec.sample_urls.length > 0 ? (
              <div className="tool-recs-banner__urls">
                {rec.sample_urls.slice(0, 3).map((u) => (
                  <a key={u} href={u} target="_blank" rel="noopener noreferrer">{u}</a>
                ))}
              </div>
            ) : null}
          </li>
        ))}
      </ul>
      <div className="tool-recs-banner__actions">
        {typeof onEnableDefaults === 'function' ? (
          <button
            type="button"
            className="btn btn-sm btn-primary"
            disabled={enabling}
            onClick={onEnableDefaults}
          >
            {enabling ? (
              <><i className="fas fa-spinner fa-spin" /> Enabling…</>
            ) : (
              <><i className="fas fa-magic" /> Make these defaults available</>
            )}
          </button>
        ) : (
          <Link className="btn btn-sm btn-primary" to="/settings/tools">
            <i className="fas fa-tools" /> Open Tools
          </Link>
        )}
      </div>
    </div>
  );
}
